import fetch from "@lib/fetch";
import { API } from "../../config";
import axios from "axios";

export const createCourierBook = (token, orderId) => {
  return fetch(`${API}/v1/orders/${orderId}/rebook`,{
    mode: 'cors',
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getTrackingById = (token, id) => {
  return fetch(`${API}/v1/trackings/${id}`,{
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
  .then(response => {
    return response.json()
  })
  .catch(error => {
    console.log(error);
  })
};

export const getCouriers = async (token) => {
  const res = await axios.get(`${API}/v1/public/couriers`, {
    mode: 'cors',
    method: "GET",
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  if(res.data.success) {
    const couriers = await res.data.couriers.reduce((r,i) => {
      r.push({
        courierName:i.courier_name,
        courierCode:i.courier_code,
        courierServiceName:i.courier_service_name,
        courierServiceCode:i.courier_service_code,
        tier: i.tier,
        description: i.description,
        serviceType: i.service_type,
        shippingType: i.shipping_type,
        shipmentDurationRange: i.shipment_duration_range,
        shipmentDurationUnit: i.shipment_duration_unit,
      });
      return r
    },[]);
    return {
      success:true,
      couriers
    }
  } else {
    alert(res.data.message);
  }
};